// CSV download helpers
function csvEscape(v) {
  if (v == null) return "";
  const s = String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function downloadCSV(filename, headers, rows) {
  const lines = [headers.map(csvEscape).join(",")];
  for (const r of rows) lines.push(r.map(csvEscape).join(","));
  const csv = lines.join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function couplesToCSV(couples, groupName = "group") {
  const headers = [
    "Couple #", "Male Ring", "Female Ring",
    "Egg 1", "Egg 2", "Egg 3", "Egg 4", "Egg 5", "Egg 6",
  ];
  for (let i = 1; i <= 6; i++) {
    headers.push(`Chick ${i} Ring`, `Chick ${i} Hatch`);
  }
  const rows = couples.map((c) => {
    const eggs = (c.egg_dates || []).concat(["", "", "", "", "", ""]).slice(0, 6);
    const chicks = (c.chicks || []).concat([
      { ring: "", hatch_date: "" }, { ring: "", hatch_date: "" }, { ring: "", hatch_date: "" },
      { ring: "", hatch_date: "" }, { ring: "", hatch_date: "" }, { ring: "", hatch_date: "" },
    ]).slice(0, 6);
    const row = [c.couple_no, c.male_ring || "", c.female_ring || "", ...eggs];
    for (const ch of chicks) row.push(ch.ring || "", ch.hatch_date || "");
    return row;
  });
  const safe = groupName.replace(/[^a-z0-9_-]+/gi, "_");
  downloadCSV(`couples_${safe}.csv`, headers, rows);
}

export function birdsToCSV(birds, groupName = "group") {
  const headers = [
    "Row #", "Ring", "Sex", "Mutation",
    "Father Ring", "Father Mutation",
    "Mother Ring", "Mother Mutation",
  ];
  const rows = birds.map((b) => [
    b.row_no, b.ring || "", b.sex || "", b.mutation || "",
    b.father_ring || "", b.father_mutation || "",
    b.mother_ring || "", b.mother_mutation || "",
  ]);
  const safe = groupName.replace(/[^a-z0-9_-]+/gi, "_");
  downloadCSV(`birds_${safe}.csv`, headers, rows);
}

// --- 21-day hatch reminders ---
function parseDate(s) {
  if (!s) return null;
  const d = new Date(s + "T00:00:00");
  if (isNaN(d.getTime())) return null;
  return d;
}

function daysBetween(a, b) {
  const ms = b.getTime() - a.getTime();
  return Math.round(ms / 86400000);
}

export function computeHatchReminders(couples, incubationDays = 21) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const reminders = [];
  for (const c of couples) {
    const eggs = c.egg_dates || [];
    const chicks = c.chicks || [];
    for (let i = 0; i < eggs.length; i++) {
      const ed = parseDate(eggs[i]);
      if (!ed) continue;
      const chick = chicks[i];
      const hatched = chick && (chick.hatch_date || chick.ring);
      if (hatched) continue;
      const expected = new Date(ed);
      expected.setDate(expected.getDate() + incubationDays);
      const diff = daysBetween(today, expected);
      if (diff < -2) continue; // stop reminding from the 3rd day after the expected hatch
      let status = "upcoming";
      if (diff < 0) status = "overdue";
      else if (diff === 0) status = "today";
      else if (diff <= 3) status = "soon";
      reminders.push({
        couple_no: c.couple_no,
        egg_index: i,
        egg_date: eggs[i],
        expected_hatch: expected.toISOString().slice(0, 10),
        days_remaining: diff,
        status,
      });
    }
  }
  reminders.sort((a, b) => a.days_remaining - b.days_remaining);
  return reminders;
}
